// extracted by mini-css-extract-plugin
export default {"disableTabList":"contentConnectMap_disableTabList__E2qBT"};